import Grid from "@mui/material/Grid";
import {
  FormCurrencyField,
  FormHomeTypeSelect,
  FormModelYearAutocomplete,
  FormOccupancyTypeSelect,
} from "@covertree/ui";

import { UseFormReturn } from "react-hook-form";
import { useTheme } from "@mui/material/styles";
import { CoverageManufacturerSelect } from "./CoverageManufacturerSelect";
import { EventEditableFields } from "@redux/event/types";

interface HomeDetailsProps {
  editableFields?: EventEditableFields;
  form: UseFormReturn;
}
export default function HomeDetails({
  editableFields,
  form: {
    control,
    formState: { defaultValues, isSubmitting },
  },
}: HomeDetailsProps) {
  const theme = useTheme();

  const otherFieldsDisabled =
    !!editableFields && !editableFields.allOtherFieldsEditable;

  return (
    <Grid container spacing={1}>
      <Grid item xs={12}>
        <FormOccupancyTypeSelect
          name="occupancyType"
          control={control}
          disabled={isSubmitting || otherFieldsDisabled}
          inputStyle={{ backgroundColor: theme.palette.background.default }}
        />
      </Grid>
      <Grid item xs={12}>
        <CoverageManufacturerSelect
          name="manufacturer"
          control={control}
          defaultValue={defaultValues.manufacturer}
          disabled={isSubmitting || otherFieldsDisabled}
          optional
        />
      </Grid>
      <Grid item xs={8}>
        <FormHomeTypeSelect
          control={control}
          disabled={isSubmitting || otherFieldsDisabled}
          optional
        />
      </Grid>
      <Grid item xs={4}>
        <FormModelYearAutocomplete
          control={control}
          defaultValue={defaultValues.modelYear}
          disabled={isSubmitting || otherFieldsDisabled}
          inputStyle={{
            backgroundColor: theme.palette.background.default,
            paddingRight: "16px !important",
          }}
          optional
        />
      </Grid>
      <Grid item xs={12}>
        <FormCurrencyField
          id="homeCoverageLimit"
          name="homeCoverageLimit"
          label="Home Coverage Limit (Coverage A)"
          control={control}
          disabled={isSubmitting || otherFieldsDisabled}
          defaultValue={defaultValues.homeCoverageLimit || null}
          optional
        />
      </Grid>
      <Grid item xs={12}>
        <FormCurrencyField
          id="otherStructuresLimit"
          name="otherStructuresLimit"
          label="Other Structures Limit (Coverage B)"
          control={control}
          disabled={isSubmitting || otherFieldsDisabled}
          defaultValue={defaultValues.otherStructuresLimit || null}
          optional
        />
      </Grid>
      <Grid item xs={12}>
        <FormCurrencyField
          id="personalPropertyLimit"
          name="personalPropertyLimit"
          label="Personal Property Coverage Limit (Coverage C)"
          control={control}
          disabled={isSubmitting || otherFieldsDisabled}
          defaultValue={defaultValues.personalPropertyLimit || null}
          optional
        />
      </Grid>
      <Grid item xs={12}>
        <FormCurrencyField
          id="personalLiabilityLimit"
          name="personalLiabilityLimit"
          label="Personal/Premises Liability Limit (Coverage E)"
          control={control}
          disabled={isSubmitting || otherFieldsDisabled}
          defaultValue={defaultValues.personalLiabilityLimit || null}
        />
      </Grid>
      <Grid item xs={12}>
        <FormCurrencyField
          id="medicalPaymentsLimit"
          name="medicalPaymentsLimit"
          label="Medical Payments to Others Limit (Coverage F)"
          control={control}
          disabled={isSubmitting || otherFieldsDisabled}
          defaultValue={defaultValues.medicalPaymentsLimit || null}
          optional
        />
      </Grid>
      <Grid item xs={12}>
        <FormCurrencyField
          id="animalLiabilityLimit"
          name="animalLiabilityLimit"
          label="Animal Liability Limit"
          control={control}
          disabled={isSubmitting || otherFieldsDisabled}
          defaultValue={defaultValues.animalLiabilityLimit || null}
          optional
        />
      </Grid>
      <Grid item xs={12}>
        <FormCurrencyField
          id="standardDeductibleLimit"
          name="standardDeductibleLimit"
          label="Standard Deductible Limit"
          control={control}
          disabled={isSubmitting || otherFieldsDisabled}
          defaultValue={defaultValues.standardDeductibleLimit || null}
          optional
        />
      </Grid>
    </Grid>
  );
}
